import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';
import { formatUnixTimestamp } from 'Deer/pages/MyData/CheckIns/helper';
import {
  CHECK_INS_STATUS_LABELS,
  CHECK_INS_STATUS_COLORS,
  type CheckInsHistoryInstance,
} from 'Deer/pages/MyData/CheckIns/types';

import { TagColored } from 'uiToolkitV1/Tag';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

type CheckInsMetaFilterProps = {
  checkInsHistory: CheckInsHistoryInstance[];
  selectedCheckIn: CheckInsHistoryInstance | null;
  setSelectedCheckIn: (checkIn: CheckInsHistoryInstance | null) => void;
};

export const CheckInsMetaFilter = ({
  checkInsHistory,
  selectedCheckIn,
  setSelectedCheckIn,
}: CheckInsMetaFilterProps) => {
  if (!selectedCheckIn) return null;

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip style={{ marginTop: '12px' }}>
          <TextBodyMedium bold>Check-in date: {formatUnixTimestamp(selectedCheckIn.dueDateTS)}</TextBodyMedium>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent
        align="start"
        style={{ minWidth: '450px', maxHeight: '400px', overflow: 'auto', padding: '8px' }}
      >
        <DropdownRadioGroup
          value={`${selectedCheckIn.checkinUpdateInstanceId}`}
          onValueChange={(value) => {
            const checkIn = checkInsHistory.find((item) => item.checkinUpdateInstanceId === Number(value));
            if (checkIn) setSelectedCheckIn(checkIn);
          }}
        >
          {checkInsHistory.map((item) => (
            <DropdownRadioItem key={item.checkinUpdateInstanceId} value={`${item.checkinUpdateInstanceId}`}>
              <TextBodyMedium mr="4px" whiteSpace="nowrap">
                {formatUnixTimestamp(item.dueDateTS)}
              </TextBodyMedium>
              <TagColored color={CHECK_INS_STATUS_COLORS[item.status]} whiteSpace="nowrap">
                {CHECK_INS_STATUS_LABELS[item.status]}
              </TagColored>
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};
